import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * Cart quantity selector supporting BOTH the stock +/- stepper and a
 * <select> dropdown layout.
 *
 * The dropdown layout renders no +/- buttons. The stock component requires
 * them and reads `.disabled` off them in connectedCallback + updateButtonStates,
 * which threw mid-morph and aborted the cart re-render (the "needs a refresh"
 * bug). Here we make the buttons optional everywhere.
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  requiredRefs = ['quantityInput'];

  connectedCallback() {
    const { minusButton, plusButton } = this.refs;
    const hasButtons = !!(minusButton && plusButton);

    if (hasButtons) {
      // Stepper layout → stock behaviour is fine.
      super.connectedCallback();
    } else {
      this.serverDisabledMinus = true;
      this.serverDisabledPlus = true;

      const input = this.refs.quantityInput; // the <select>
      if (input) {
        input.addEventListener('change', () => {
          // Reuse the base component's handler — it builds and dispatches
          // the QuantitySelectorUpdateEvent (value + cartLine) that
          // cart-items-component listens for via ThemeEvents.quantitySelectorUpdate.
          this.onQuantityChange();
        });
      }
      this.initialized = true;
    }
  }

  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // absolute cart max
  }

  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    if (!minusButton || !plusButton) return; // dropdown layout: nothing to do

    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    minusButton.disabled = value <= min;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}

// import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

// /**
//  * A custom element that allows the user to select a quantity in the cart.
//  * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
//  * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
//  *
//  * @extends {QuantitySelectorComponent}
//  */
// class CartQuantitySelectorComponent extends QuantitySelectorComponent {
//   /**
//    * Gets the effective maximum value for cart quantity selector
//    * Cart page: uses absolute max (how much can be in cart total)
//    * @returns {number | null} The effective max, or null if no max
//    */
//   getEffectiveMax() {
//     const { max } = this.getCurrentValues();
//     return max; // Cart uses absolute max, not max minus cart quantity
//   }

//   /**
//    * Updates button states based on current value and limits
//    * Cart buttons are always managed client-side, never server-disabled
//    */
//   updateButtonStates() {
//     const { minusButton, plusButton } = this.refs;
//     const { min, value } = this.getCurrentValues();
//     const effectiveMax = this.getEffectiveMax();

//     // Cart buttons are always dynamically managed
//     minusButton.disabled = value <= min;
//     plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
//   }
// }

// if (!customElements.get('cart-quantity-selector-component')) {
//   customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
// }
